import { ButtonType } from '@ardoq/button';
import { ButtonWithDropdown } from '@ardoq/dropdown-menu';
import { IconName } from '@ardoq/icons';
import { WIDGET_OPTIONS_BUTTON_ID } from '../../consts';
import { isTruthy } from '@ardoq/common-helpers';
import { type I18nLocale, t } from '@ardoq/i18n';

interface EditModeOptionsButtonProps {
  canEdit: boolean;
  copyWidget: VoidFunction;
  deleteWidget: VoidFunction;
  i18nLocale: I18nLocale;
}

const EditModeOptionsButton = ({
  canEdit,
  copyWidget,
  deleteWidget,
  i18nLocale,
}: EditModeOptionsButtonProps) => {
  return (
    <ButtonWithDropdown
      data-click-id={WIDGET_OPTIONS_BUTTON_ID}
      dataTestId={WIDGET_OPTIONS_BUTTON_ID}
      className="show-only-on-hover"
      alignMenuTo="right"
      tooltipText={t(
        i18nLocale,
        'dashboard:widgetOptions.moreOptions',
        'More options'
      )}
      disablePortal
      options={[
        canEdit && {
          label: t(i18nLocale, 'dashboard:widgetOptions.copy', 'Copy'),
          iconName: IconName.COPY,
          clickId: 'widget-copy',
          onClick: copyWidget,
        },
        {
          label: t(i18nLocale, 'dashboard:widgetOptions.delete', 'Delete'),
          iconName: IconName.DELETE,
          clickId: 'widget-delete',
          onClick: deleteWidget,
        },
      ].filter(isTruthy)}
      iconName={IconName.MORE_VERT}
      buttonType={ButtonType.GHOST}
    />
  );
};

export { EditModeOptionsButton };
